import { RedoButton } from './RedoButton';
import { UndoButton } from './UndoButton';

export const EditButtons = () => (
  <section>
    <UndoButton />
    <RedoButton />
  </section>
);
